import React from 'react'
import { Skeleton, Button, Form, Input, message } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../BaseComponent'
import ISpecie from '../../../interfaces/ISpecie'
import { SearchRequest, SpecieSaveRequest }from '../../../services/api/interfaces/ApiRequest'

type SpecieProps = BaseFormComponentProps & {
  uuid?: string,
  data?: ISpecie,
  error: any | null,

  loading: boolean,
  history: any,

  loadSpecie: (args: SearchRequest) => void,

  dispatchCreate: (args: SpecieSaveRequest) => Promise<any>,
  dispatchUpdate: (args: SpecieSaveRequest) => Promise<any>
}

export default class Specie extends FormComponent<SpecieProps> {

  state = {
    saving: false,
    loaded: false
  }

  componentDidMount() {
    const { uuid, loadSpecie } = this.props

    // Check permissions
    this.validateAccessPermissions()

    if (uuid) {
      loadSpecie({
        search: {
          uuid
        }
      })
    }
  }

  componentDidUpdate(prevProps: SpecieProps, prevState) {
    const wasLoading = prevProps.loading && !this.props.loading
    let newState = Object.assign({}, this.state)

    // Check permissions
    this.validateAccessPermissions()

    // We are loaded?
    if (!this.state.loaded) {
      // If our entity was loaded or if we are creating a new one, that's means that we are loaded :P
      if (wasLoading || !this.props.uuid) {
        newState.loaded = true
      } 
    } else {
      // We are saving
      if (this.state.saving && wasLoading) {
        // Add the new role name to url
        if (!this.props.uuid && this.props.data) {
          this.props.history.replace(`/admin/specie/${this.props.data.uuid}`)
        }

        if (!this.props.error) {
          message.success('Specie saved successfully!')
        } else {
          message.error('Failed to save user. Error: ' + this.props.error)
        }

        newState.saving = false
      }
    }

    // Update if changed
    if (newState.loaded !== this.state.loaded) {
      this.setState(newState)
    }
  }

  handleSave = (values: any) => {
    const { uuid, dispatchCreate, dispatchUpdate } = this.props

    let payload: SpecieSaveRequest = {
      specie: {
        ...values
      }
    }

    if (uuid) {
      payload = {
        specie: {
          ...payload.specie,
          uuid
        }
      }
      
      dispatchUpdate(payload)
      this.setState({
        saving: true
      })
    } else {
      dispatchCreate(payload)
      this.setState({
        saving: true
      })
    }
  }

  render() {
    const { uuid, data, loading } = this.props
    const { loaded } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    let values:any = {
      name: ''
    }

    if (uuid) {
      values = {
        ...data || {}
      }
    }

    return (
      <Form
        name="species"
        initialValues={values}
        layout="vertical"
        onFinish={this.handleSave}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Missing a name for the species'
            }
          ]}
        >
          <Input />
        </Form.Item>
        
        <Form.Item style={{marginTop: 32}}>
          <Button type="primary" htmlType="submit" size="large" loading={loading} ref={(refs) => this.actionRefs.save = refs} block>
            Save
          </Button>
        </Form.Item>
      </Form>
    )
  }
}